import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { InferType } from "yup";
import {
  createShiftValidationForm,
} from "../../utils/validationSchemas";

//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import ShiftForm from "./ShiftForm";

const CreateShift = (props: any) => {
  const { handleCreate, isLoading } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    watch,
    clearErrors,
  } = useForm<InferType<typeof createShiftValidationForm>>({
    resolver: yupResolver(createShiftValidationForm),
  });

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <ShiftForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
          watch={watch}
        />
      </FormLayout>
    </>
  );
};

export default CreateShift;
